import Seo from '../components/Seo';
import React from 'react';
import logo from '../assets/images/vine-centre-logo.png';
import building from '../assets/images/vine_centre_advert[1].jpg';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import VolunteerActivismOutlinedIcon from '@mui/icons-material/VolunteerActivismOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import ChildCareOutlinedIcon from '@mui/icons-material/ChildCareOutlined';

export default function About() {
  return (
    <div className="aboutus-root">
      <Seo
        title="About the Vine Centre | North Belfast Community Hub"
        description="Learn about the Vine Centre's mission, history, and the services we provide to empower the North Belfast community."
      />
      {/* Hero Section */}
      <div className="aboutus-hero">
        <img src={building} alt="Vine Centre Building" className="aboutus-hero-bg" />
        <div className="aboutus-hero-overlay"></div>
        <div className="aboutus-hero-content">
          <img src={logo} alt="Vine Centre Logo" className="aboutus-logo" />
          <h1>About the Vine Centre</h1>
          <p>Empowering North Belfast since 1970</p>
        </div>
      </div>
      <div className="aboutus-content">
        {/* Story Section */}
        <section className="aboutus-story aboutus-card">
          <h2>Our Story</h2>
          <p>
            The Vine Centre was established in 1997 as a response to the social and economic needs of the
            local community in North Belfast. Our mission is to empower individuals and families by
            providing a range of support services, educational programs, and community development
            initiatives.
          </p>
          <p>
            We believe in the potential of every individual to contribute positively to society, and we
            work tirelessly to remove the barriers that prevent people from achieving their goals.
          </p>
        </section>
        {/* Features Section */}
        <section className="aboutus-features aboutus-card">
          <h2>What We Do</h2>
          <div className="aboutus-feature-grid">
            <div>
              <InfoOutlinedIcon className="aboutus-icon" />
              <h3>Information & Advice</h3>
              <p className="aboutus-features-desc">
                Providing essential information and advice services to help navigate various challenges.
              </p>
            </div>
            <div>
              <VolunteerActivismOutlinedIcon className="aboutus-icon" />
              <h3>Volunteer Opportunities</h3>
              <p className="aboutus-features-desc">
                Offering a range of volunteer opportunities to get involved and make a difference.
              </p>
            </div>
            <div>
              <LightbulbOutlinedIcon className="aboutus-icon" />
              <h3>Training & Workshops</h3>
              <p className="aboutus-features-desc">
                Conducting training sessions and workshops to develop skills and knowledge.
              </p>
            </div>
            <div>
              <ChildCareOutlinedIcon className="aboutus-icon" />
              <h3>Childcare Services</h3>
              <p className="aboutus-features-desc">
                Providing quality childcare services to support parents and guardians.
              </p>
            </div>
          </div>
        </section>
        {/* Milestones Section */}
        <section className="aboutus-card aboutus-milestones">
          <LightbulbOutlinedIcon className="aboutus-icon" />
          <h2>Milestones</h2>
          <div className="aboutus-timeline">
            <div className="aboutus-timeline-item">
              <div className="aboutus-timeline-dot"></div>
              <div className="aboutus-timeline-content">
                <span className="aboutus-milestone-year">1970</span>
                <span>Vine Centre founded as an Advice Centre</span>
              </div>
            </div>
            <div className="aboutus-timeline-item">
              <div className="aboutus-timeline-dot"></div>
              <div className="aboutus-timeline-content">
                <span className="aboutus-milestone-year">2004</span>
                <span>Bulrush Daycare Nursery officially opened</span>
              </div>
            </div>
            <div className="aboutus-timeline-item">
              <div className="aboutus-timeline-dot"></div>
              <div className="aboutus-timeline-content">
                <span className="aboutus-milestone-year">Present</span>
                <span>Expanded to offer a wide range of community services and programmes</span>
              </div>
            </div>
          </div>
        </section>
        {/* Vision and Bulrush Section */}
        <div className="aboutus-bottom-row">
          {/* Vision Card */}
          <section className="aboutus-vision aboutus-card">
            <h2>Our Vision for the Future</h2>
            <p>
              Our plans for the future involve increasing all our existing services, as well as developing
              new areas of interest. Our expanded vision includes bringing employment to the area, which
              has one of the highest unemployment rates in Belfast, and regenerating the area both
              economically and environmentally, as Crumlin is now recognised as one of the most deprived
              areas in Belfast, having been neglected by previous initiatives. We aim to do all this
              while creating the opportunity and potential to enable cross-community contact, as well
              as overcoming internal community tensions.
            </p>
            <p>
              The Vine Centre is always looking for committed people to share and work towards this
              vision.
            </p>
          </section>
          {/* Bulrush Card */}
          <section className="aboutus-bulrush aboutus-card">
            <h2>Bulrush Daycare Nursery</h2>
            <p>
              The Bulrush Daycare Nursery officially opened in November 2004. This 36-place daycare
              facility provides a safe learning environment for children, while increasing their
              parents' potential to gain employment or to enter training.
            </p>
          </section>
        </div>
      </div>

      {/* Call to Action */}
      <div style={{ textAlign: 'center', margin: '48px 0 0 0' }}>
        <a
          href="/contact"
          style={{
            display: 'inline-block',
            background: 'var(--vine-accent)',
            color: 'var(--vine-dark)',
            padding: '1em 2.4em',
            borderRadius: 32,
            fontWeight: 800,
            fontSize: '1.13rem',
            textDecoration: 'none',
            boxShadow: '0 4px 18px rgba(123,30,58,0.13)',
            border: 'none',
            letterSpacing: '0.5px',
            transition: 'background 0.18s, color 0.18s, box-shadow 0.18s',
            marginTop: 12,
            cursor: 'pointer',
          }}
        >
          Get Involved with the Vine Centre
        </a>
      </div>
      <style>{`
              .aboutus-root {
                max-width: 1100px;
                margin: 0 0 0 32px;
                padding: 0 8px 48px 0;
              }
              .aboutus-hero {
                max-width: 1100px;
                margin: 0 0 40px 0;
              }
              .aboutus-card, .aboutus-bottom-row {
                margin-left: 0;
              }
              .aboutus-hero {
                position: relative;
                width: 100%;
                max-width: 1100px;
                min-height: 260px;
                border-radius: 22px;
                overflow: hidden;
                margin: 0 auto 40px auto;
                box-shadow: 0 8px 32px rgba(123,30,58,0.13);
                background: linear-gradient(120deg, var(--vine-main) 0%, var(--vine-accent) 100%);
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .aboutus-hero-bg {
                width: 100%;
                height: 260px;
                object-fit: cover;
                opacity: 0.18;
                position: absolute;
                top: 0; left: 0;
                z-index: 1;
              }
              .aboutus-hero-overlay {
                position: absolute;
                top: 0; left: 0; right: 0; bottom: 0;
                background: linear-gradient(120deg, rgba(123,30,58,0.18) 0%, rgba(255,255,255,0.10) 100%);
                z-index: 2;
              }
              .aboutus-hero-content {
                position: relative;
                z-index: 3;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 100%;
                padding: 32px 0 24px 0;
              }
              .aboutus-logo {
                height: 90px;
                background: #fff;
                border-radius: 18px;
                padding: 12px;
                box-shadow: 0 2px 12px rgba(123,30,58,0.10);
                margin-bottom: 10px;
              }
              .aboutus-hero-content h1 {
                color: var(--vine-secondary);
                font-weight: 900;
                font-size: 2.7rem;
                text-shadow: 0 2px 12px rgba(44,0,0,0.18);
                margin: 0;
                letter-spacing: 1px;
              }
              .aboutus-hero-content p {
                color: var(--vine-secondary);
                font-weight: 500;
                font-size: 1.18rem;
                margin: 18px 0 0 0;
                text-shadow: 0 2px 8px rgba(44,0,0,0.10);
              }
              .aboutus-card {
                background: #fff;
                border-radius: 18px;
                box-shadow: 0 4px 24px rgba(123,30,58,0.10);
                padding: 2.2rem 1.7rem;
                margin: 0 auto 32px auto;
                max-width: 900px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
              }
              .aboutus-card h2 {
                color: var(--vine-main);
                font-weight: 800;
                font-size: 1.35rem;
                margin-bottom: 16px;
                letter-spacing: 0.5px;
              }
              .aboutus-icon {
                color: var(--vine-accent);
                margin-bottom: 8px;
                font-size: 2rem;
              }
              .aboutus-story {
                background: var(--vine-secondary);
                color: var(--vine-dark);
              }
              .aboutus-features {
                border: 2px solid var(--vine-accent);
              }
              .aboutus-feature-grid {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
                gap: 0.7rem 1.2rem;
                width: 100%;
                margin-bottom: 1.2rem;
              }
              .aboutus-feature-grid div {
                background: var(--vine-secondary);
                color: var(--vine-main);
                border-radius: 10px;
                padding: 0.7em 1em;
                font-weight: 600;
                font-size: 1.02rem;
                text-align: center;
              }
              .aboutus-features-desc {
                margin-top: 0.5rem;
                color: var(--vine-dark);
              }
              .aboutus-milestones {
                background: linear-gradient(120deg, #f7e9f0 0%, #f3f6fa 100%);
                border-left: 5px solid var(--vine-accent);
                position: relative;
                overflow: visible;
              }
              .aboutus-timeline {
                position: relative;
                margin-left: 18px;
                padding-left: 18px;
                border-left: 3px solid var(--vine-accent);
                display: flex;
                flex-direction: column;
                gap: 22px;
              }
              .aboutus-timeline-item {
                display: flex;
                align-items: flex-start;
                position: relative;
              }
              .aboutus-timeline-dot {
                width: 16px;
                height: 16px;
                background: var(--vine-accent);
                border-radius: 50%;
                position: absolute;
                left: -26px;
                top: 2px;
                border: 3px solid #fff;
                box-shadow: 0 2px 8px rgba(123,30,58,0.10);
              }
              .aboutus-timeline-content {
                display: flex;
                flex-direction: row;
                align-items: baseline;
                gap: 0.7em;
                font-size: 1.08rem;
                color: var(--vine-dark);
                background: none;
              }
              .aboutus-milestone-year {
                font-weight: 800;
                color: var(--vine-accent);
                font-size: 1.08rem;
                min-width: 60px;
                letter-spacing: 0.5px;
              }
              .aboutus-bottom-row {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 2rem;
                max-width: 900px;
                margin: 0 auto 32px auto;
                align-items: stretch;
              }
              .aboutus-vision, .aboutus-bulrush {
                min-width: 0;
                width: 100%;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
              }
              @media (max-width: 900px) {
                .aboutus-bottom-row {
                  grid-template-columns: 1fr;
                  gap: 1.2rem;
                }
                .aboutus-vision, .aboutus-bulrush {
                  width: 100%;
                  min-width: 0;
                }
              }
            `}</style>
    </div>
  );
}
